import React, { Component } from 'react'
import { withTheme } from 'styled-components'
import { Modal } from 'antd'
import moment from 'moment'

import { getDateInLocalTZ, toAbsCurrency, getResourcePerm } from '../../../Utils/util'
import { apiPOSTReq } from '../../../Utils/api'
import TableView from '../../Reusable/TableView'
import { ErrorAlert } from '../../Reusable/Alert'
import { Text } from '../../Reusable/Text'
import { Flex, FlexColumn } from '../../Reusable/Container'
import { TextButton } from '../../Reusable/Button'
import { ACHDetail, InstantDetail, CheckDetail, WireDetail } from '../../Banking/Reusable/AccountDetail'
import environment from '../../../environment'
import ModalClose from '../../../Images/modal-close.png'

class BillPaymentTable extends Component {

    state = {

    }

    viewTxnDetails = (options) => {
        var { paymentId, paymentMethod } = options || {};
        var body = {
            viewBy: paymentMethod === 'Wire' ? "WIRE_TFER" : paymentMethod === 'Instant' ? 'INSTANT_TFER' : paymentMethod === 'CHECK' ? 'CHECK_DEPOSIT' : paymentMethod,
            objectId: paymentId,
            fetchByPrimaryKey: true,
        }

        this.setState({ [`${paymentId}Loading`]: true });

        console.log("BillPaymentTable getObjectDetail body", body)

        apiPOSTReq(`${environment.bbBaseUrl}/bb/getObjectDetail`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                var data = resp || {}
                console.log("BillPaymentTable getObjectDetail", data)
                if (err) throw Error(err)
                if (!resp.result) throw Error(resp.responseMessage || resp.error)

                this.setState({ 
                    detailModalVisible: true, 
                    achTransferObj: data?.achTransferObj, 
                    instantTransferObj: data?.instantTransferObj, 
                    checkDepositObj: data?.checkDepositObj,
                    wireTransferObj: data?.wireTransferObj,
                })
            } catch (error) {
                console.log("BillPaymentTable getObjectDetail error", error)
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            } finally {
                this.setState({ [`${paymentId}Loading`]: false })
            }
        })
    }

    render() {
        var { payments } = this.props
        var { detailModalVisible, achTransferObj, instantTransferObj, wireTransferObj } = this.state

        const paymentsPerm = getResourcePerm("BusinessBanking.Payments")
        var columns = [
            {
                title: 'Date',
                dataIndex: 'paymentDate',
                render: (date, record) => record.createdSource == "CODAT" ? getDateInLocalTZ(date) : <a style={{ textDecoration: "underline", color: "#1199FF" }}>{getDateInLocalTZ(date)}</a>
            },
            {
                title: 'Amount',
                dataIndex: 'amount',
                render: amt => `$${toAbsCurrency(amt, 2)}`
            },
            {
                title: 'Status',
                dataIndex: 'paymentStatus',
            },
        ]

        return (
            <>
                <TableView
                    id='bill-payments-table'
                    tableLayout='auto'
                    columns={columns}
                    dataSource={payments}
                    rowKey='paymentId'
                    titleText={'Payment History'}
                    descText={this.props.descText || 'Prior payments made on this bill'}
                    borderView={this.props.borderView}
                    onRow={(record, rowIndex) => {
                        return {
                            onClick: event => { this.viewTxnDetails(record) }
                        }
                    }}
                />

                <Modal
                    visible={detailModalVisible}
                    width={900}
                    closable={true}
                    maskClosable={true}
                    style={{ borderRadius: '8px !important' }}
                    footer={null}
                    destroyOnClose={true}
                    onCancel={() => this.setState({ detailModalVisible: false })}
                    closeIcon={<img width='24px' height='24px' src={ModalClose} />}
                >
                    <FlexColumn start>
                        <Text heading>Transaction details</Text>
                        <Text margin='0 0 24px'>Quick view of transaction details from your bank account</Text>
                        {achTransferObj && <ACHDetail viewReturn={false} record={achTransferObj} detail={achTransferObj} billPayment />}
                        {instantTransferObj && <InstantDetail record={instantTransferObj} detail={instantTransferObj} billPayment instant />}
                        {wireTransferObj && <WireDetail viewReturn={false} record={wireTransferObj} detail={wireTransferObj} billPayment />}
                    </FlexColumn>
                </Modal>
            </>
        )
    }
}

export default withTheme(BillPaymentTable)